export const getLastVariableData = (state) => state.variables?.lastData;
